import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Menu, MenuItem } from '@material-ui/core';
import _ from 'lodash';
import i18n from 'i18n/i18n';
import PencilIcon from '../icons/pencil';
import { SpinnerIcon } from '../../theme/icons';

const { localize } = i18n.loc;

const styles = theme => ({
	root: {
		width: '40px',
		height: '40px',
		margin: '10px 25px',
		border: '0px solid',
		borderRadius: '5px',
		overflow: 'hidden',
		position: 'relative'
	},
	rootOverlay: {
		cursor: 'pointer'
	},
	photo: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		objectPosition: 'top'
	},
	hoverOverlay: {
		width: '100%',
		height: '100%',
		position: 'absolute',
		left: 0,
		top: 0,
		opacity: 0,
		transition: 'opacity 150ms ease-out',
		backgroundColor: '#2e3f4f'
	},
	hoverOverlayVisible: {
		opacity: 0.6
	},
	pencil: {
		position: 'absolute',
		left: 'calc(50% - 12px)',
		top: 'calc(50% - 12px)',
		pointerEvents: 'none',
		opacity: 0,
		transition: 'opacity 150ms ease-out',
		color: 'white'
	},
	pencilVisible: {
		opacity: 1
	},
	loadingIcon: {
		display: 'block',
		height: '30px',
		width: '30px',
		margin: '0 auto',
		fill: '#96DCFD',
		animation: 'spin 2s linear infinite'
	},
	'@keyframes spin': {
		'0': {
			transform: 'rotate(0deg)'
		},
		'100%': {
			transform: 'rotate(360deg)'
		}
	}
});

class SmartFieldPhotoPicker extends Component {
	constructor(props) {
		super(props);
		this.state = {
			objectUrl: '',
			anchorEl: null,
			hovering: false
		};
	}

	componentDidUpdate(prevProps) {
		const { photoUrlOrFile } = this.props;
		const { objectUrl } = this.state;

		if (photoUrlOrFile !== prevProps.photoUrlOrFile) {
			if (objectUrl) {
				URL.revokeObjectURL(objectUrl);
			}

			if (_.isString(photoUrlOrFile)) {
				this.setState({ objectUrl: '' });
			} else {
				this.setState({ objectUrl: URL.createObjectURL(photoUrlOrFile) });
			}
		}
	}

	componentWillUnmount() {
		const { objectUrl } = this.state;
		if (objectUrl) {
			URL.revokeObjectURL(objectUrl);
		}
	}

	handleMenuOpen = (event) => {
		this.setState({ anchorEl: event.currentTarget.parentElement });
	};

	handleMenuClose = () => {
		this.setState({ anchorEl: null });
	};

	handleMouseEnter = () => {
		this.setState({ hovering: this.props.showProgress ? false : true });
	};

	handleMouseLeave = () => {
		this.setState({ hovering: false });
	};

	render() {
		const {
			classes,
			defaultPhoto,
			photoUrlOrFile = '',
			onSelectPhoto,
			onCropPhoto,
			onRemovePhoto,
			showProgress
		} = this.props;

		const { objectUrl, anchorEl, hovering } = this.state;

		const showDefaultPhoto = !photoUrlOrFile && defaultPhoto && !showProgress;
		const photoUrl = objectUrl || (_.isString(photoUrlOrFile) ? photoUrlOrFile : '');

		showProgress && hovering && this.setState({ hovering: false });

		return (
			<div
				className={`${classes.root} ${hovering ? classes.rootOverlay : ''}`}
				onMouseEnter={this.handleMouseEnter}
				onMouseLeave={this.handleMouseLeave}
			>
				{showDefaultPhoto && defaultPhoto}
				{photoUrlOrFile && !showProgress && <img className={classes.photo} src={photoUrl} alt="photo preview" />}
				{showProgress && <SpinnerIcon className={classes.loadingIcon} />}
			
				<div
					className={`${classes.hoverOverlay} ${hovering ? classes.hoverOverlayVisible : ''}`}
					onClick={showProgress ? undefined : this.handleMenuOpen}
				/>
				<PencilIcon className={`${classes.pencil} ${hovering ? classes.pencilVisible : ''}`} />

				<Menu
					anchorEl={anchorEl}
					open={Boolean(anchorEl)}
					onClose={this.handleMenuClose}
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'left' }}
				>
					<MenuItem
						onClick={() => {
							onSelectPhoto && onSelectPhoto();
							this.handleMenuClose();
						}}
					>
						{localize('smartfield-photo-picker-upload-photo')}
					</MenuItem>
					{onCropPhoto && (
						<MenuItem
							disabled={!photoUrlOrFile}
							onClick={() => {
								onCropPhoto();
								this.handleMenuClose();
							}}
						>
							{localize('smartfield-photo-picker-crop-photo')}
						</MenuItem>
					)}
					<MenuItem
						disabled={!photoUrlOrFile}
						onClick={() => {
							onRemovePhoto && onRemovePhoto();
							this.handleMenuClose();
						}}
					>
						{localize('smartfield-photo-picker-remove-photo')}
					</MenuItem>
				</Menu>
			</div>
		);
	}
}

SmartFieldPhotoPicker.propTypes = {
	photoUrlOrFile: PropTypes.object,
	classes: PropTypes.string,
	defaultPhoto: PropTypes.object,
	onSelectPhoto: PropTypes.function,
	onCropPhoto: PropTypes.function,
	onRemovePhoto: PropTypes.function,
	showProgress: PropTypes.bool
};

export default withStyles(styles)(SmartFieldPhotoPicker);



// WEBPACK FOOTER //
// ./src/components/SmartFieldPhotoPicker/SmartFieldPhotoPicker.js